export const validateEmail = (value, intl) => {
  const isfilled =
    !value || value.length <= 0
      ? intl.formatMessage({
          id: "field.validator.message"
        })
      : null;

  if (isfilled) return isfilled;

  var regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return !regexEmail.test(String(value).toLowerCase())
    ? intl.formatMessage({
        id: "email.validator.message"
      })
    : null;
};

export const validateRequired = (value, intl) => {
  return !value || value.length == 0
    ? intl.formatMessage({
        id: "error.requiredField"
      })
    : null;
};

export const validatePasscode = (value, intl) => {
  return !value || value.length == 0
    ? intl.formatMessage({
        id: "error.requiredField"
      })
    : null;
};
